import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../../components/PromoIconography/MyWaitroseIcon/MyWaitroseIcon.scss';
const reductionIsOversized = reduction => reduction && reduction.length > 4;
const additionalMessaging = additionalReduction => {
    if (!additionalReduction)
        return null;
    const additionalStyle = reductionIsOversized(additionalReduction)
        ? styles.oversized
        : styles.additional;
    return (React.createElement("div", { "data-testid": "myWaitrose-messaging" },
        React.createElement("span", { className: "sr-only" },
            "and an extra ",
            additionalReduction,
            " off with the my Waitrose card"),
        React.createElement("span", { className: styles.bridge, "aria-hidden": "true" }, "and an extra"),
        React.createElement("span", { className: additionalStyle, "aria-hidden": "true" },
            additionalReduction,
            React.createElement("br", null),
            "OFF"),
        React.createElement("span", { className: styles.bridge, "aria-hidden": "true" }, "with")));
};
const MyWaitroseIcon = props => {
    const { display, roundel, additionalReduction } = props;
    if (!display)
        return null;
    const { supercharged } = props;
    let myWaitroseStyle = supercharged ? styles.supercharged : styles.wrapper;
    if (roundel && !supercharged)
        myWaitroseStyle = styles.banner;
    return (React.createElement("div", { className: myWaitroseStyle },
        additionalMessaging(additionalReduction),
        React.createElement("div", { className: styles.image })));
};
MyWaitroseIcon.displayName = 'MyWaitroseIcon';
MyWaitroseIcon.defaultProps = {
    display: false,
    additionalReduction: '',
    roundel: false,
    supercharged: false,
};
MyWaitroseIcon.propTypes = {
    display: PropTypes.bool,
    additionalReduction: PropTypes.string,
    roundel: PropTypes.bool,
    supercharged: PropTypes.bool,
};
export default MyWaitroseIcon;
//# sourceMappingURL=index.js.map